import { useContext } from 'react'

import { useRouter } from 'next/router'

import { FilterContext } from '@/context/filterContext'

export const useQueryActiveTab = () => {
  const { query } = useRouter()

  if (!!query && !!query.filter) {
    const filters = JSON.parse(query.filter)

    return filters.tab || null
  }
  return null
}

const stripSorting = (c) => {
  const columnClone = { ...c }
  delete columnClone.defaultSortOrder
  delete columnClone.sortOrder
  return columnClone
}

export const useColumnFilters = (columns) => {
  const { routeFilters } = useContext(FilterContext)

  let filteredColumns = columns

  // FILTERING
  filteredColumns = filteredColumns.map((c) => {
    const filteredValue = routeFilters?.filters?.[c.dataIndex]

    return { ...c, filteredValue: filteredValue || null }
  })

  // SORTING
  let hasSortBeenApplied = false

  // give priority to any sorting applied by clicking on the table
  filteredColumns = filteredColumns.map((c) => {
    if (hasSortBeenApplied) return c

    if (routeFilters?.sort?.column?.dataIndex === c.dataIndex) {
      hasSortBeenApplied = true
      return { ...c, sortOrder: routeFilters?.sort?.order }
    }

    return c
  })

  // give secondary priority to any sorting applied by default
  filteredColumns = filteredColumns.map((c) => {
    if (hasSortBeenApplied) return c

    const sortlessColumn = stripSorting(c)

    // don't apply the default sort in the "cancelled" sort state
    const applyDefaultSort =
      routeFilters?.sort?.column === undefined &&
      routeFilters?.sort?.field === undefined

    if (applyDefaultSort && c.defaultSortOrder) {
      hasSortBeenApplied = true
      return { ...sortlessColumn, sortOrder: c.defaultSortOrder }
    }

    return sortlessColumn
  })

  return filteredColumns
}
